export default filename => (_, getState) => {
    const { assetId, localRules, selected } = getState().editorReducer
    const selectedRules = localRules.filter(r => selected.has(r.index))

    const blob = new Blob(
        [
            JSON.stringify(
                {
                    rules: selectedRules,
                    assetId: assetId
                },
                null,
                4
            )
        ],
        { type: 'application/json' }
    )
    const link = document.createElement('a')

    link.download = filename || 'alarm-rules-' + assetId + '.json'
    link.href = window.URL.createObjectURL(blob)
    link.dataset.downloadurl = ['application/json', link.download, link.href].join(':')

    link.dispatchEvent(
        new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
        })
    )
    link.remove()
}
